import { render, staticRenderFns } from "./ExhibitorsMeeting.vue?vue&type=template&id=df1b87e4&scoped=true&"
import script from "./ExhibitorsMeeting.vue?vue&type=script&lang=js&"
export * from "./ExhibitorsMeeting.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitorsMeeting.vue?vue&type=style&index=0&id=df1b87e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1b87e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
